import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";

interface FileStatsChartProps {
  title: string;
  datakey: string;
  data: FileContent[];
  selectedData: FileContent[];
}

interface FileContent {
  totalSize: number;
  maxFileSize: number;
  totalFiles: number;
  userLastLoginDate?: number;
  userId?: string;
  nickName?: string;
  displayMonth?: string;
  displayDate?: string;
  courseId?: string;
  courseName?: string;
  totalTeams?: number;
  teamCreationDate?: number;
  startTime?: number;
  endTime?: number;
}

const FileStatsChart: React.FC<FileStatsChartProps> = ({ title, datakey, data, selectedData }) => {
  return (
    <div className="w-full min-h-[83vh] max-h-[83vh] p-4">
      <div className="flex justify-between">
        <h2 className="mb-4 text-xl font-semibold text-center">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </h2>
        <h2 className="mb-4 text-xl font-semibold text-center">{title}</h2>
        <div className="mb-4 text-lg font-semibold text-center">
          총 {(data.reduce((acc, file) => acc + file.totalSize, 0) / 1024).toFixed(2)} GB (
          {data.reduce((acc, file) => acc + file.totalFiles, 0).toLocaleString()}개)
        </div>
      </div>
      <ResponsiveContainer width="100%" height={700}>
        <BarChart data={data} margin={{ top: 10, right: 25, bottom: 5, left: 10 }}>
          <CartesianGrid strokeDasharray="1 1" />
          <XAxis
            dataKey={datakey}
            interval={title === "팀별 파일 통계" ? Math.floor(data?.length / 2) : Math.floor(data?.length / 7)} // 7개만 라벨링
            tick={{ fontSize: 12, textAnchor: `${title === "팀별 파일 통계" ? "start" : "middle"}` }}
          />
          <YAxis
            unit="MB"
            tickFormatter={(value: number) => value.toLocaleString()}
            tick={{ fontSize: 12 }}
            label={{ value: "Size", angle: -90, offset: 0, position: "insideLeft" }}
          />
          <Tooltip formatter={(value: number) => `${value.toLocaleString()} MB`} />
          <Bar dataKey="totalSize">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={selectedData.includes(entry) ? "#FF0000" : "#8884d8"} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FileStatsChart;
